import React, { useCallback, useState, useEffect } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';

import '../../libs/bulma.min.css';
import './QueueList.css';

import { exportSelectAllQueues } from '../../services';
import accessLocalStorage from '../../services/accessLocalStorage';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare } from '@fortawesome/free-solid-svg-icons';
import QueueAgents from '../Queues/QueueAgents';
import QueueIdentifyOnHold from '../Queues/QueueIdentifyOnHold';
import QueueIdentifyAnswered from '../Queues/QueueIdentifyAnswered';
import StatsQueue from './components/Callcenter/QueueStats'

const ipGetRequest = window.location.href;
const myIP = ipGetRequest.split('/')[2].includes(':') ? ipGetRequest.split('/')[2].split(':')[0] : ipGetRequest.split('/')[2];

const createAuthenticatedSocket = () => {
  try {
    const userData = accessLocalStorage.getUserLocalStorage();
    const token = userData?.token;
    
    if (!token) {
      console.error('❌ Token de autenticação não encontrado no localStorage');
      return null;
    }
    
    console.log('🔐 Conectando ao WebSocket com autenticação...');
    
    const socket = io(`//${myIP}/ws`, {
      path: '/ws/socket.io/',
      query: {
        token: token
      },
      auth: {
        token: token
      }
    });
    
    socket.on('connect', () => {
      console.log('✅ Conectado ao WebSocket com autenticação! Socket ID:', socket.id);
    });
    
    socket.on('connect_error', (error) => {
      console.error('❌ Erro na conexão WebSocket:', error.message);
    });
    
    socket.on('disconnect', (reason) => {
      console.log('🔌 WebSocket desconectado:', reason);
    });
    
    return socket;
  } catch (error) {
    console.error('❌ Erro ao criar conexão WebSocket autenticada:', error);
    return null;
  }
};

const socket = createAuthenticatedSocket();

function QueueList(queue) {
  const { queueName, queueRemove } = queue;
  
  let url = window.location.href;
  url = url.split('/')[2];
  
  if (!socket) {
    console.error('❌ Não foi possível estabelecer conexão WebSocket autenticada');
    return (
      <div className="queue-card error-card">
        <div className="queue-header error-header">
          <svg className="error-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <div>
            <h3 className="error-title">Erro de Autenticação</h3>
            <p className="error-subtitle">Não foi possível conectar ao WebSocket</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="queue-card">
      <div className="queue-header">
        <button 
          className="queue-remove-btn" 
          aria-label="Remover fila" 
          onClick={() => queueRemove(queueName)}
        >
          <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        
        <div className="queue-header-content">
          <svg className="queue-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          <div>
            <h2 className="queue-title">{queueName}</h2>
            <p className="queue-subtitle">Monitoramento ativo</p>
          </div>
        </div>
      </div>

      <div className="queue-stats-wrapper">
        <StatsQueue queue={queueName} socketio={socket} />
      </div>

      <div className="queue-tables">
        <div className="queue-table-section">
          <div className="queue-table-header waiting">
            <svg className="table-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3>Em Espera</h3>
          </div>
          <div className="queue-table-wrapper">
            <table className="queue-table">
              <thead>
                <tr>
                  <th>Telefone</th>
                  <th>Tempo</th>
                </tr>
              </thead>
              <tbody>
                <QueueIdentifyOnHold queue={queueName} socketio={socket} />
              </tbody>
            </table>
          </div>
        </div>

        <div className="queue-table-section">
          <div className="queue-table-header answered">
            <svg className="table-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
            <h3>Em Atendimento</h3>
          </div>
          <div className="queue-table-wrapper">
            <table className="queue-table">
              <thead>
                <tr>
                  <th>Telefone</th>
                  <th>Atendente</th>
                  <th>Tempo</th>
                </tr>
              </thead>
              <tbody>
                <QueueIdentifyAnswered queue={queueName} socketio={socket} />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QueueList;